"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBReformHousePositive = function SvgBReformHousePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M22.937 133.836a5.514 5.514 0 01-5.412-5.49l-.139-52.855a1.461 1.461 0 00-1.485-1.43l-11.312.026a3.632 3.632 0 01-2.575-6.213c10.01-9.942 28.633-28.424 45.256-44.946L68.64 1.663a5.795 5.795 0 018.177.023l67.348 67.524a2.109 2.109 0 11-2.989 2.976L73.83 4.662a1.573 1.573 0 00-2.22-.039L50.24 25.882C34.16 41.865 16.222 59.712 5.991 69.833l9.9-.023a5.683 5.683 0 015.71 5.67l.139 52.883a1.271 1.271 0 001.29 1.295l39.78-.107a1.285 1.285 0 001.288-1.291l-.021-6.429a8.675 8.675 0 016.54-8.443l-.06-21.52a2.108 2.108 0 114.216-.01l.062 23.374a2.107 2.107 0 01-2.102 2.113 4.446 4.446 0 00-4.44 4.468l.02 6.429a5.507 5.507 0 01-5.485 5.525l-39.78.106-.111-.037z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M49.277 107.17a2.107 2.107 0 01-1.859-3.004l23.498-49.758a2.108 2.108 0 013.815.003l23.449 49.63a2.107 2.107 0 01-1.9 3.009l-9.837.025a2.108 2.108 0 11-.01-4.216l6.484-.02-20.094-42.595-20.177 42.707 18.744-.052a2.108 2.108 0 01.011 4.215l-22.082.057h-.042z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M76.129 133.697a2.108 2.108 0 01.031-4.215l46.37-.125a1.285 1.285 0 001.288-1.298l-.179-53.348L72.6 23.94 30.896 65.85a2.107 2.107 0 11-2.983-2.976l41.862-42.082a3.927 3.927 0 012.83-1.166 3.877 3.877 0 012.79 1.152l51.833 51.558c.396.394.619.928.62 1.486l.185 54.226a5.507 5.507 0 01-5.492 5.524l-46.37.126-.042-.001z",
    fill: "#1B7"
  })));
};

var _default = SvgBReformHousePositive;
exports["default"] = _default;